import * as React from 'react';
import { paymentsActionTypes } from '../payments-action-types';
import axios from 'axios';
import download from 'downloadjs';
import { BASE_URL } from '../../../../config/environmentConfig';
import { sendSentryMessage } from '../../../utils/sentry-helper';
import { IPaymentsAction } from '../payments-interfaces';
import { ISettlementsFilters } from '../../../components/settlements/SettlementsFilterSection';
import { GET } from '../../store-helper';
import { IPaginationData, ISettlementsTableRowData } from '../../../interfaces/funds';

export const fetchSettlementsData = async (searchParams: ISettlementsFilters): Promise<IPaginationData> => {
  try {

    const params = { ...searchParams };

    if (!params.pageNumber) {
      params.pageNumber = 1;
    }

    if (!params.pageSize) {
      params.pageSize = 10;
    }

    return await GET({ pathname: `${BASE_URL.ORDERS}/settlements?isLatest=false`, params });

  } catch (e) {
    sendSentryMessage({ name: `GET Fetch settlements data error`, context: e });
    console.log(e);
  }
};

export const fetchLatestSettlementsData = async (searchParams: ISettlementsFilters): Promise<IPaginationData> => {
  try {
    const params = { ...searchParams };

    if (!params.pageNumber) {
      params.pageNumber = 1;
    }

    if (!params.pageSize) {
      params.pageSize = 10;
    }

    return await GET({ pathname: `${BASE_URL.ORDERS}/settlements/latest`, params });

  } catch (e) {
    sendSentryMessage({ name: `GET Fetch settlements data error`, context: e });
    console.log(e);
  }
};

export const fetchPartnerSettlementsData = async (searchParams: ISettlementsFilters): Promise<IPaginationData> => {
  try {

    const params = { ...searchParams };

    if (!params.pageNumber) {
      params.pageNumber = 1;
    }

    if (!params.pageSize) {
      params.pageSize = 10;
    }

    return await GET({ pathname: `${BASE_URL.ORDERS}/settlements/partner`, params });

  } catch (e) {
    sendSentryMessage({ name: `GET Fetch settlements data error`, context: e });
    console.log(e);
  }
};

export interface IParams {
  pageSize: number,
  pageNumber : number,
  from?: any,
  to?: string | number | boolean | Date,
  mid?: string | number | boolean | Date,
  responseType?: string,
  batchType?: string,
}

interface IExportCSVSettlementsData {
  dispatch: React.Dispatch<IPaymentsAction>;
  size: number;
  chosenMerchant: string;
  filtersFromUrl?: ISettlementsFilters;
}
export const exportCSVSettlementsData = async ({ dispatch, size, chosenMerchant, filtersFromUrl }: IExportCSVSettlementsData): Promise<void> => {
  dispatch({ type: paymentsActionTypes.SET_EXPORT_CSV_LOADING, payload: true });
  try {
    // const from = dateFilterState?.[0] ? getFormattedDate(dateFilterState[0], 'yyyy-MM-dd') : undefined;
    // const to = dateFilterState?.[1] ? getFormattedDate(dateFilterState[1], 'yyyy-MM-dd') : undefined;
    const params: IParams = {
      ...filtersFromUrl,
      pageSize: size,
      pageNumber: 1,
      // from,
      // to,
      responseType: 'blob',
    };
    if (chosenMerchant) {
      params.mid = chosenMerchant;
    }
    const res = await axios(`${BASE_URL.ORDERS}/settlements/export`, { params });

    if (res.data) {
      const blob = new Blob([res.data], { type: 'text/csv' });
      download(blob, 'Settlements.csv');
    }

    dispatch({ type: paymentsActionTypes.SET_EXPORT_CSV_LOADING, payload: false });
  } catch (e) {
    console.log(e);
    dispatch({ type: paymentsActionTypes.SET_EXPORT_CSV_LOADING, payload: false });
  }
};

export const fetchSettlementDataById = async (id: string): Promise<ISettlementsTableRowData> => {
  try {

    return await GET({ pathname: `${BASE_URL.ORDERS}/settlements/${id}` });

  } catch (e) {
    console.log('fetchSettlementDataById error', e);
  }
};
